import { render, staticRenderFns } from "./WithdrawDepot.vue?vue&type=template&id=748c17b0&scoped=true"
import script from "./WithdrawDepot.vue?vue&type=script&lang=ts"
export * from "./WithdrawDepot.vue?vue&type=script&lang=ts"
import style0 from "./WithdrawDepot.vue?vue&type=style&index=0&id=748c17b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c17b0",
  null
  
)

export default component.exports